import React from 'react'
import { SkyInformationPopover } from './SkyPopover'

export const HomeBuiltPopover = (props) => {
  return (
    <SkyInformationPopover eventId={'home-built'}>
      <div className="text-small">
        A UAS and its constituent spares (if applicable) that is both designed
        and{' '}
      </div>
      <div className="text-small margin-top-small">
        constructed by the insured or UAS operator or affiliated person
      </div>
    </SkyInformationPopover>
  )
}
